import { useState, useEffect } from 'react';
import api from '@services/api';

function useAdditionalFieldsHook() {
  const [apiArea, setApiArea] = useState(false);
  const [customFields, setCustomFields] = useState([]);

  useEffect(() => {
    api.get('/admin/products/new').then((response) => {
      setApiArea(response.data.additional_fields.external_code);
      setCustomFields(response.data.additional_fields.metafields);
    });
  }, []);
  return { apiArea, customFields };
}

export default useAdditionalFieldsHook;
